import { InjectionToken } from '@angular/core';

export const NewsDetailTemplateStyleToyota: NewsDetailTemplateStyleData = {
    templateName: 'variantA',
    headline: 'text-24 lg:text-48 leading-28 lg:leading-48 font-book mb-4',
    imageSize: {
        desktop: {
            width: 841,
            height: 500,
        },
        tablet: {
            width: 841,
            height: 500,
        },
        mobile: {
            width: 390,
            height: 224,
        },
    },
    newsContainer: 'w-full max-w-845 mx-auto lg:text-center pb-40 lg:pb-80',
    imageContainer: 'relative mb-32 lg:mb-24',
    midHeadline: 'font-semibold text-14 leading-20 mb-24 lg:mb-16',
    subHeadline: 'text-16 leading-20 font-book mb-24 lg:mb-16',
    date: 'text-12 leading-18 mb-4',
    heroHeadline: {
        container: 'absolute bottom-24 left-0 bg-accentSecondary-bg min-w-300 h-24 py-2 pl-80 pr-40',
        text: 'text-14 leading-20 font-book',
    },
    text: 'text-light-text text-16 leading-24 font-book flex flex-col gap-16',
    textContainer: 'max-w-1108 mx-auto px-24 pt-40 lg:pt-130 pb-40 lg:pb-160',
    dealerContact: {
        singleDealerSection: 'pt-30 lg:pb-90 pb-48 lg:pt-80',
        subDealerSection: 'bg-dark-bg pb-30 lg:pb-48 pt-30 lg:pt-40',
    },
};

export const NewsDetailTemplateStyleJaguar: NewsDetailTemplateStyleData = {
    templateName: 'variantA',
    headline: 'text-24 lg:text-48 leading-28 lg:leading-48 font-light mb-4',
    imageSize: {
        desktop: {
            width: 841,
            height: 500,
        },
        tablet: {
            width: 841,
            height: 500,
        },
        mobile: {
            width: 390,
            height: 224,
        },
    },
    newsContainer: 'w-full max-w-845 mx-auto lg:text-center pb-40 lg:pb-80',
    imageContainer: 'relative mb-32 lg:mb-24',
    midHeadline: 'font-semibold text-14 leading-20 mb-24 lg:mb-16',
    subHeadline: 'text-16 leading-20 font-light mb-24 lg:mb-16',
    date: 'text-12 leading-18 mb-4',
    heroHeadline: {
        container: 'absolute bottom-24 left-0 bg-accentSecondary-bg min-w-300 h-24 py-2 pl-80 pr-40',
        text: 'text-14 leading-20 font-light',
    },
    text: 'text-16 leading-20 font-light flex flex-col gap-16',
    textContainer: 'px-16 lg:px-58',
    dealerContact: {
        singleDealerSection: 'pt-30 pb-48 lg:pt-80 lg:py-80',
        subDealerSection: 'pt-30 pb-48 lg:pt-40 lg:pb-85',
    },
};

export const NewsDetailTemplateStyleLandRover: NewsDetailTemplateStyleData = {
    templateName: 'variantB',
    headline:
        'font-primary font-bold text-18 lg:text-24 leading-21 lg:leading-24 uppercase text-light-text text-left mb-24',
    imageSize: {
        desktop: {
            width: 1440,
            height: 440,
        },
        tablet: {
            width: 1440,
            height: 440,
        },
        mobile: {
            width: 390,
            height: 224,
        },
    },
    newsContainer: 'w-full max-w-1440 mx-auto lg:text-center pb-40 lg:pb-80 border-b-grey-200 border-b-1',
    imageContainer: 'relative mb-32 lg:mb-40',
    midHeadline: 'font-secondary font-semibold text-left text-14 leading-21 mb-24 text-light-text',
    subHeadline: 'font-secondary font-normal text-left text-14 leading-21 text-light-text mb-24',
    date: 'font-secondary text-left text-11 leading-14 text-light-text mb-4',
    heroHeadline: {
        container: 'lg:hidden absolute bottom-24 left-0 bg-grey-400 h-24 py-4 px-24',
        text: 'text-dark-text text-11 font-secondary',
    },
    text: 'font-secondary font-normal text-left text-14 leading-21 text-light-text flex flex-col gap-24',
    textContainer: 'lg:max-w-996 mx-auto px-24 lg:px-58',
    dealerContact: {
        singleDealerSection: 'pt-30 pb-48 lg:pt-80 lg:pb-90',
        subDealerSection: 'pt-30 pb-48 lg:pt-40 lg:pb-85',
    },
};

export const NewsDetailTemplateStyleOpel: NewsDetailTemplateStyleData = {
    templateName: 'variantB',
    headline: 'text-24 lg:text-48 leading-28 lg:leading-48 font-light mb-4',
    imageSize: {
        desktop: {
            width: 841,
            height: 500,
        },
        tablet: {
            width: 841,
            height: 500,
        },
        mobile: {
            width: 390,
            height: 224,
        },
    },
    newsContainer: 'w-full max-w-845 mx-auto lg:text-center pb-40 lg:pb-80',
    imageContainer: 'relative mb-32 lg:mb-24',
    midHeadline: 'font-semibold text-14 leading-20 mb-24 lg:mb-16',
    subHeadline: 'text-16 leading-20 font-light mb-24 lg:mb-16',
    date: 'text-12 leading-18 mb-4',
    heroHeadline: {
        container:
            'position-unset md:absolute bottom-24 left-0 bg-accentSecondary-bg min-w-300 min-h-24 h-auto py-2 px-16 md:pl-80 md:pr-40',
        text: 'text-14 leading-20 font-light',
    },
    text: 'text-16 leading-20 font-light flex flex-col gap-16',
    textContainer: 'px-16 lg:px-58',
    dealerContact: {
        singleDealerSection: 'md:py-72',
        subDealerSection: 'py-32 md:pt-40 md:pb-56',
    },
};

export const NewsDetailTemplateStyleKia: NewsDetailTemplateStyleData = {
    templateName: 'variantB',
    headline: 'text-18 lg:text-24 leading-24 lg:leading-40 font-semibold mb-24',
    newsContainer: 'pb-40 lg:pb-80',
    imageContainer: 'relative mb-32 lg:mb-24',
    midHeadline: 'text-14 leading-20 font-semibold mb-24',
    subHeadline: 'text-14 leading-20 font-semibold mb-24',
    date: 'text-10 leading-20 mb-4 text-grey-400',
    heroHeadline: {
        container: 'absolute bottom-24 left-0 bg-dark-bg h-24 py-2 px-24 lg:px-50 flex items-center',
        text: 'text-10 leading-17 text-dark-text',
    },
    text: 'text-14 leading-20 text-grey-400 flex flex-col gap-16',
    textContainer: 'container',
    dealerContact: {
        singleDealerSection: 'pt-30 pb-48 lg:pt-80 lg:pb-90 border-t-1 border-grey-200',
        subDealerSection: 'pt-30 pb-48 lg:pt-40 lg:pb-85 border-t-1 border-grey-200 px-24',
    },
    imageSize: {
        desktop: {
            width: 1440,
            height: 400,
        },
        tablet: {
            width: 841,
            height: 500,
        },
        mobile: {
            width: 375,
            height: 210,
        },
    },
};

export const NewsDetailTemplateStyleSuzuki: NewsDetailTemplateStyleData = {
    templateName: 'variantB',
    headline: 'text-24 text-left lg:text-40 leading-28 lg:leading-40 font-bold mb-24',
    imageSize: {
        desktop: {
            width: 841,
            height: 500,
        },
        tablet: {
            width: 841,
            height: 500,
        },
        mobile: {
            width: 390,
            height: 224,
        },
    },
    newsContainer: 'w-full lg:text-center',
    imageContainer: 'relative',
    midHeadline: 'font-semibold text-left text-16 leading-20 mb-24 lg:mb-16',
    subHeadline: 'text-16 text-left leading-20 font-book mb-24 lg:mb-16',
    date: 'text-12 text-left leading-18 mb-4',
    heroHeadline: {
        container: 'absolute bottom-24 left-0 bg-accentSecondary-bg px-24 lg:px-50 py-4',
        text: 'text-12 text-light-text leading-18 font-book',
    },
    text: 'text-dark-text text-left text-16 leading-24 font-book flex flex-col gap-16',
    textContainer: 'max-w-880 mx-auto pt-32 lg:pt-40 pb-56 px-24 lg:px-0',
    dealerContact: {
        singleDealerSection: 'pt-30 lg:pb-90 pb-48 lg:pt-80',
        subDealerSection: 'bg-dark-bg pb-40 lg:pb-48 pt-30 lg:pt-40',
    },
};

export const NewsDetailTemplateStyleToken = new InjectionToken<NewsDetailTemplateStyleData>(
    'NewsDetailTemplateStyleToken',
);

export function provideNewsDetailTemplateStyleData(style: NewsDetailTemplateStyleData) {
    return {
        provide: NewsDetailTemplateStyleToken,
        useValue: style,
    };
}

export interface NewsDetailTemplateStyleData {
    headline: string;
    templateName: 'variantA' | 'variantB';
    newsContainer: string;
    imageContainer: string;
    imageSize: {
        desktop: {
            width: number;
            height: number;
        };
        tablet: {
            width: number;
            height: number;
        };
        mobile: {
            width: number;
            height: number;
        };
    };
    midHeadline: string;
    subHeadline: string;
    date: string;
    heroHeadline: {
        container: string;
        text: string;
    };
    text: string;
    textContainer: string;
    dealerContact: {
        singleDealerSection: string;
        subDealerSection: string;
    };
}
